/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_5_2Inputs */



/**
* | output |
* | --- |
* | "Combining with Compliance Copilot for advanced analysis" |
*
* @param {Guardrails_Section_5_2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_5_2 = /** @type {((inputs?: Guardrails_Section_5_2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_5_2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kombination mit dem Compliance Copilot für erweiterte Analyse")
	return /** @type {LocalizedString} */ ("Combining with Compliance Copilot for advanced analysis")
});